import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Brand";
import { SiteFooter } from "@/components/SiteFooter";

export function LegalDoc({ title, updated, intro, children }) {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-100 sticky top-0 z-20">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center justify-between">
          <Logo className="h-9" />
          <Link to="/" className="text-sm text-slate-500 flex items-center gap-1 hover:text-blue-600 transition-colors"><ArrowLeft className="w-4 h-4" /> Home</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-10">
        <h1 className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight text-slate-900">{title}</h1>
        {updated && <p className="text-sm text-slate-400 mt-2">Ultimo aggiornamento: {updated}</p>}
        {intro && <p className="mt-5 text-slate-600 leading-relaxed">{intro}</p>}
        <div className="mt-8 space-y-8">{children}</div>
      </main>
      <SiteFooter />
    </div>
  );
}

export function Section({ n, title, children }) {
  return (
    <section data-testid={`legal-section-${n}`}>
      <h2 className="font-display font-bold text-xl text-slate-900">{n}. {title}</h2>
      <div className="mt-3 space-y-3 text-slate-600 leading-relaxed text-[15px]">{children}</div>
    </section>
  );
}

export function Bullets({ items }) {
  return (
    <ul className="space-y-2 list-disc pl-5">
      {items.map((it, i) => <li key={i}>{it}</li>)}
    </ul>
  );
}
